import { render, staticRenderFns } from "./valmistumispyynnot-virkailija-yek.vue?vue&type=template&id=09d60d26&scoped=true&"
import script from "./valmistumispyynnot-virkailija-yek.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynnot-virkailija-yek.vue?vue&type=script&lang=ts&"
import style0 from "./valmistumispyynnot-virkailija-yek.vue?vue&type=style&index=0&id=09d60d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d60d26",
  null
  
)

export default component.exports